module.exports = __webpack_public_path__ + "static/media/iconProjetEducatif.31b76c23.svg";